import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { LotType } from '../../../store/entities/lotTypes/lotTypes.types';
import { APIManagerConfig } from '../apiManager';

const LotTypesServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getLotTypes: (): Promise<LotType[]> => HTTPBase.get(`farm/${config.farmId}/lottypes`).then((res) => res.data),
    createLotType: (data: Partial<LotType>, formName: FormName): Promise<LotType[]> =>
      HTTPBase.post(`farm/${config.farmId}/lottypes`, data, { headers: { formName } }).then((res) => res.data),
    updateLotType: (id: string, data: Partial<LotType>, formName: FormName): Promise<LotType[]> =>
      HTTPBase.patch(`farm/${config.farmId}/lottypes/${id}`, data, { headers: { formName } }).then((res) => res.data),
    deleteLotType: (id: string, formName: FormName): Promise<any> =>
      HTTPBase.delete(`farm/${config.farmId}/lottypes/${id}`, { headers: { formName } }).then((res) => res.data),
  };
};

export default LotTypesServiceFactory;
